export enum LocationPaths {
  Auth = '/auth',
  SignIn = '/sign-in',
  PasswordResetRequest = '/password-reset-request',
  NotFound = '/not-found',
  VideoCalls = '/video-calls',
  HealthQuestionnaire = '/health-questionnaire',
  Questionnaire = '/questionnaire/:surveyKind',
  SensorSelection = '/sensor-selection',
  FreeVideoCall = '/free-video-call',
  ScheduleCall = '/schedule-call',
  Dpp = '/dpp',
  Glp = '/care'
}

export enum VideoCallsPath {
  Insurance = 'insurance',
  EmailAddress = 'email-address',
  SignUp = 'sign-up',
  State = 'state',
  AddressForm = 'address-form',
  Completed = 'completed',
  AddPaymentMethod = 'add-payment-method',
  Questionnaire = 'questionnaire/:surveyKind',
  ScheduleCall = 'schedule-call',
  AddAppointmentAgenda = 'add-appointment-agenda'
}

export enum DppPath {
  Chat = 'chat',
  Dashboard = 'dashboard',
  Completed = 'completed',
  Ineligible = 'ineligible',
  IneligibleVideoCalls = 'ineligible/video-calls'
}

export enum GlpPath {
  Goal = 'goal',
  Bmi = 'bmi',
  Ineligible = 'ineligible',
  NotRightProgram = 'not-right-program',
  BmiTooLow = 'bmi-too-low',
  SignUp = 'sign-up',
  Checkout = 'checkout',
  PaymentSuccessful = 'payment-successful',
  Dashboard = 'dashboard',
  ScheduleCall = 'schedule-call',
  Chat = 'chat',
  Account = 'account'
}

export interface LocationState {
  from: LocationStateFrom
}

export interface LocationStateFrom {
  pathname: LocationPaths
}
